export default {
    SET_ENROLLMENTS_DETAILS: 'SET_ENROLLMENTS_DETAILS',
    SET_ENROLLMENTS_DETAILS_CLEANUP: 'SET_ENROLLMENTS_DETAILS_CLEANUP',
    SET_COVERAGES_DETAILS: 'SET_COVERAGES_DETAILS',
    SET_COVERAGES_DETAILS_CLEANUP: 'SET_COVERAGES_DETAILS_CLEANUP'
  };